import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
export var tableClasses = {
    cell: 'ct-cell',
    cellHead: 'ct-cell-head',
    row: 'ct-row',
    rowClickable: 'ct-row-clickable',
    empty: 'ct-empty',
};
export var TableRoot = styled(Box)(function () {
    var _a, _b, _c;
    return (_a = {
            width: '100%',
            backgroundColor: baseColors.fullWhite,
            borderRadius: 8,
            border: "1px solid ".concat(baseColors.greyPreset[40]),
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            '& .MuiTableContainer-root': {
                flex: 1,
                overflow: 'auto',
            },
            '& .MuiTableCell-stickyHeader': {
                backgroundColor: baseColors.fullWhite,
                zIndex: 2,
            }
        },
        _a["& .".concat(tableClasses.cell)] = (_b = {
                padding: '12px 16px',
                fontSize: 12,
                color: baseColors.darkPreset[10],
                borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
                whiteSpace: 'nowrap'
            },
            _b["&.".concat(tableClasses.cellHead)] = {
                backgroundColor: baseColors.fullWhite,
                color: baseColors.darkPreset[10],
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                lineHeight: 1.5,
            },
            _b),
        _a["& .".concat(tableClasses.row)] = (_c = {
                cursor: 'default',
                '&:last-of-type td': {
                    borderBottom: 'none',
                }
            },
            _c["&.".concat(tableClasses.rowClickable)] = {
                cursor: 'pointer',
                '&:hover td': {
                    backgroundColor: baseColors.fullWhite,
                },
            },
            _c),
        _a["& .".concat(tableClasses.empty)] = {
            padding: '40px 16px',
            textAlign: 'center',
            borderBottom: 'none',
            color: baseColors.darkPreset[10],
            fontSize: 12,
        },
        _a);
});
